'use client';

import { useTranslation } from 'react-i18next';

import { CardCodeField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-code.js';
import { CardExpiryField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-expiry.js';
import { CreditCardFields } from '@sola/ark-core/molecules/credit-card-fields/credit-card-fields.js';
import { CardNameField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-name.js';
import { CardNumberField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-number.js';
import { CardTypeField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-type.js';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.js';
import { SupporterCCFieldsEnum } from '@sola/schema/dotcom/supporters/paymentMethods.js';

export const PaymentCCFields = () => {
  const { t } = useTranslation('my');

  return (
    <CreditCardFields>
      <CardTypeField name={SupporterCCFieldsEnum.cardType} />
      <CardNumberField name={SupporterCCFieldsEnum.cardNumber} required />

      <CardNameField name={SupporterCCFieldsEnum.nameOnCard} required />

      <div className="flex flex-row space-between gap-comfy-sm">
        <CardExpiryField name={SupporterCCFieldsEnum.expirationDate} required />

        <CardCodeField name={SupporterCCFieldsEnum.cvv} required />
      </div>
      <InputField
        name={SupporterCCFieldsEnum.nickname}
        label={t('addPaymentMethod.form.fields.cardNickName')}
        hint={t('addPaymentMethod.form.optional')}
      />
    </CreditCardFields>
  );
};
